<script>
  export let businessCode;
  export let businessName;

  const tallyPopup = new URLSearchParams({
    "tally-open": "3XBejn",
    "tally-width": "376",
    "tally-align-left": "1",
    "tally-hide-title": "1",
    "tally-overlay": "1",
    "tally-emoji-text": "👋",
    "tally-emoji-animation": "wave",
    business_code: businessCode,
    business_name: businessName,
  });
</script>

<svelte:head>
  <script async src="https://tally.so/widgets/embed.js"></script>
</svelte:head>

<div class="card border-0 shadow mb-5">
  <div class="card-body">
    <div class="card-title text-uppercase font-weight-bold">Is This Your Listing?</div>
    <p>
      Own or manage this business? Claim your listing to personalise your profile and
      share your story.
    </p>
    <div class="media-body">
      <p class="text-primary font-weight-bold mt-3">
        <a href={`#${tallyPopup}`}>
          Claim your free listing
          <i class="fa fa-long-arrow-alt-right" />
        </a>
      </p>
    </div>
  </div>
</div>
